import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import emailImage from '../assetr/email.png';
import phone from '../assetr/phone.png';
import axios from 'axios';
import './ContactPage.css';

export default function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    const data = JSON.stringify({
      email,
      name,
      number,
      subject: 'New Contact Message',
      body: message,
    });

    try {
      await axios.request({
        method: 'post',
        url: 'https://civitemail.canctests.com/',
        headers: { 'Content-Type': 'application/json' },
        data,
      });
      setSuccess('Ihre Nachricht wurde erfolgreich gesendet!');
      setName('');
      setEmail('');
      setNumber('');
      setMessage('');
    } catch (err) {
      setError('Beim Senden Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
      console.error('Error sending message:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cp-wrapper">
      {/* Back link */}
      <Link to="/" className="cp-back">
        ← Zurück
      </Link>

      {/* Divider */}
      <div className="cp-divider">
        <span className="cp-line" />
        <span className="cp-diamond">◆</span>
        <span className="cp-line" />
      </div>

      {/* Heading */}
      <h1 className="cp-heading">Kontaktieren Sie uns</h1>
      <p className="cp-subheading">MANA &middot; Ihre Eventdekoration</p>

      <div className="cp-card">
        {/* Contact info */}
        <div className="cp-info">
          <div className="cp-info-item">
            <img src={emailImage} width={34} alt="Email" />
            <div>
              <div className="cp-info-label">E-Mail</div>
              <div className="cp-info-value">info@mana-ie.de</div>
            </div>
          </div>
          <div className="cp-info-item">
            <img src={phone} width={34} alt="Phone" />
            <div>
              <div className="cp-info-label">Telefon</div>
              <div className="cp-info-value">
                +49 172 9362862<br />
                +49 172 9362262
              </div>
            </div>
          </div>
        </div>

        {/* Vertical separator */}
        <div className="cp-separator" />

        {/* Form */}
        <form onSubmit={handleSubmit} className="cp-form">
          <div className="cp-field">
            <label htmlFor="cp-name">Name</label>
            <input
              id="cp-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ihr Name"
              required
            />
          </div>
          <div className="cp-field">
            <label htmlFor="cp-email">E-Mail</label>
            <input
              id="cp-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ihre E-Mail"
              required
            />
          </div>
          <div className="cp-field">
            <label htmlFor="cp-number">Telefon</label>
            <input
              id="cp-number"
              type="tel"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              placeholder="Ihre Telefonnummer"
              required
            />
          </div>
          <div className="cp-field">
            <label htmlFor="cp-message">Nachricht</label>
            <textarea
              id="cp-message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Ihre Nachricht…"
              rows={4}
              required
            />
          </div>
          <button type="submit" className="cp-submit" disabled={loading}>
            {loading ? 'Sendet…' : 'Nachricht senden'}
          </button>
          {error && <p className="cp-error">{error}</p>}
          {success && <p className="cp-success">{success}</p>}
        </form>
      </div>

      {/* Footer note */}
      <p className="cp-footer-note">
        &copy; {new Date().getFullYear()} MANA GbR Event Dekoration
      </p>
    </div>
  );
}
